export default __webpack_public_path__ + "static/media/jaw-open.0310ae25.svg";